<div class="container">
  <div class="celo-dialog-header">
    <h2 class="visually-hidden">Review Celo on G2</h2>

    <button
      mat-icon-button
      aria-label="Close review"
      class="celo-dialog-close close"
      mat-dialog-close
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (state === "loading") {
    <div class="loading" role="status" aria-label="Loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="40"
      ></mat-progress-spinner>
    </div>
  }

  @if (state === "failed") {
    <div class="failed" role="alert">
      <p class="failed__message">Couldn't load the review form</p>
      <button
        mat-button
        type="button"
        class="celo-primary-button uppercase"
        (click)="retry()"
      >
        Try again
      </button>
    </div>
  } @else {
    @for (attempt of [loadAttempt]; track attempt) {
      @if (placeholderHtml) {
        <iframe
          class="form"
          title="G2 review form"
          [class.form--hidden]="state === 'loading'"
          [srcdoc]="placeholderHtml"
          (load)="onFormLoaded()"
        ></iframe>
      } @else if (reviewUrl) {
        <!--
          credentialless lets the cross-origin form load under the app's
          Cross-Origin-Embedder-Policy without the form sending its own.
        -->
        <iframe
          credentialless
          class="form"
          title="G2 review form"
          [class.form--hidden]="state === 'loading'"
          [src]="reviewUrl"
          (load)="onFormLoaded()"
        ></iframe>
      }
    }
  }
</div>
